import Dexie from 'dexie';

import Image from '@/models/image.model';
import Note from '@/models/note.model';
import Tag from '@/models/tag.model';

const db = new Dexie('litera');
db.version(1).stores({
  notes: 'uuid,created,updated',
});
db.version(2).stores({
  notes: 'uuid,created,updated,*tags',
  tags: 'name',
}).upgrade(trans => trans.notes.toCollection().modify(note => {
  note.tags = [];
  note.archived = false;
  note.deleted = false;
}));
db.version(3).stores({
  staging: 'uuid',
  images: 'uuid,noteUuid',
});

db.images.mapToClass(Image);
db.notes.mapToClass(Note);
db.staging.mapToClass(Note);
db.tags.mapToClass(Tag);

export default db;
